<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
    />

    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" title="휴게시설" tableHeaderTitle="점검항목" :isNote="false" v-model="form.inspectList" class="mt-28px" />

    <!-- 확인자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t('결재란') }}</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import * as inspectData from "./inspectData";
import TableInspectMerge from "@/components/TableInspectMerge";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import moment from "moment";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    SignField,
    TableInspectMerge,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  watch: {
    "header": {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerYear = value.year;
        this.form.headerMonth = value.month;
        this.form.headerDate = String(value.year) + String(value.month);
      },
    },
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    "form.headerYear": {
      immediate: true,
      deep: true,
      handler() {
        this.form.headerDate = String(this.form.headerYear) + String(this.form.headerMonth);
      },
    },
    "form.headerMonth": {
      immediate: true,
      deep: true,
      handler() {
        this.form.headerDate = String(this.form.headerYear) + String(this.form.headerMonth);
      },
    },
  },
  data() {
    return {
      form: {
        headerYear: moment(new Date()).format("YYYY"),
        headerMonth: moment(new Date()).format("MM"),
        headerDate: "",
        stdInfo: {},
        fileList: [],
        inspectionTitle: "휴게시설",
        inspectList: JSON.parse(JSON.stringify(inspectData.inspectTable_1)),
        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
        photoList: [],
      },
    };
  },
  computed: {
    isPostId() {
      return !!this.$route.params.postId;
    },
    postList() {
      return this.$store.state.approval.list.map((item) => this.getContent(item));
    },
  },
  methods: {
    formatMonth() {
      this.form.headerMonth = String(this.form.headerMonth).padStart(2, "0");
    },
    getTranslateDisasterValue(value) {
      const prefix = "직접입력_";
      if (typeof value === "string" && value.startsWith(prefix)) {
        return value.substring(prefix.length);
      }
      return value;
    },
    applyDisasterValue(translatedValue) {
      const prefix = "직접입력_";
      const previous = this.form.stdInfo["재해형태"];
      if (typeof previous === "string" && previous.startsWith(prefix)) {
        if (typeof translatedValue === "string" && translatedValue.length > 0) {
          this.$set(this.form.stdInfo, "재해형태", `${prefix}${translatedValue}`);
        }
        return;
      }
      this.$set(this.form.stdInfo, "재해형태", translatedValue);
    },
    translationMap() {
      const prefix = "휴게시설.휴게시설 점검표";
      const inspectList = Array.isArray(this.form.inspectList) ? this.form.inspectList : [];
      const photoList = Array.isArray(this.form.photoList) ? this.form.photoList : [];
      const fileList = Array.isArray(this.form.fileList) ? this.form.fileList : [];

      return {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,
        [`${prefix}.기본정보.점검일`]: this.form.stdInfo["점검일"],
        [`${prefix}.기본정보.점검장소`]: this.form.stdInfo["점검장소"],
        [`${prefix}.기본정보.재해형태`]: this.getTranslateDisasterValue(this.form.stdInfo["재해형태"]),
        [`${prefix}.기본정보.알림 대상자 선택`]: this.form.stdInfo["알림 대상자 선택"],
        [`${prefix}.점검표`]: inspectList.map((item) => {
          const data = item || {};
          return {
            "점검분류": data.title,
            "점검항목": data.content,
            "표시색상": data.titleColor,
            "비고(보완계획)": data["비고(보완계획)"],
          };
        }),
        [`${prefix}.결재란.작성자.이름`]: this.form.sign1.name,
        [`${prefix}.결재란.작성자.서명`]: this.form.sign1.sign,
        [`${prefix}.결재란.검토자.이름`]: this.form.sign2.name,
        [`${prefix}.결재란.검토자.서명`]: this.form.sign2.sign,
        [`${prefix}.결재란.회람자.이름`]: this.form.sign3.name,
        [`${prefix}.결재란.회람자.서명`]: this.form.sign3.sign,
        [`${prefix}.결재란.승인자.이름`]: this.form.sign4.name,
        [`${prefix}.결재란.승인자.서명`]: this.form.sign4.sign,
        [`${prefix}.사진대지`]: photoList.map((item) => {
          const data = item || {};
          return { "사진설명": data.input };
        }),
        [`${prefix}.파일첨부`]: fileList.map((item) => {
          const data = item || {};
          return {
            "파일명": data.fileName || data.name,
            "파일경로": data.url || data.path,
          };
        }),
      };
    },
    translate(translate) {
      const prefix = "휴게시설.휴게시설 점검표";

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];
      this.$set(this.form.stdInfo, "점검일", translate[`${prefix}.기본정보.점검일`]);
      this.$set(this.form.stdInfo, "점검장소", translate[`${prefix}.기본정보.점검장소`]);
      this.applyDisasterValue(translate[`${prefix}.기본정보.재해형태`]);
      this.$set(this.form.stdInfo, "알림 대상자 선택", translate[`${prefix}.기본정보.알림 대상자 선택`]);

      const inspectTranslations = translate[`${prefix}.점검표`];
      if (Array.isArray(inspectTranslations)) {
        const templateList = JSON.parse(JSON.stringify(inspectData.inspectTable_1));
        let currentList = [];
        if (this.form.inspectList && this.form.inspectList.length) {
          currentList = JSON.parse(JSON.stringify(this.form.inspectList));
        } else {
          currentList = JSON.parse(JSON.stringify(templateList));
        }
        const updatedList = inspectTranslations.map((item, index) => {
          let base = null;
          if (currentList[index]) {
            base = JSON.parse(JSON.stringify(currentList[index]));
          } else if (templateList[index]) {
            base = JSON.parse(JSON.stringify(templateList[index]));
          } else {
            base = { title: "", content: "", titleColor: "", isChecked: "" };
          }
          if (typeof item["점검분류"] === "string") {
            base.title = item["점검분류"];
          }
          if (typeof item["점검항목"] === "string") {
            base.content = item["점검항목"];
          }
          if (typeof item["표시색상"] === "string") {
            base.titleColor = item["표시색상"];
          }
          if (typeof item["비고(보완계획)"] === "string") {
            base["비고(보완계획)"] = item["비고(보완계획)"];
          }
          return base;
        });
        this.$set(this.form, "inspectList", updatedList);
      }

      this.$set(this.form.sign1, "name", translate[`${prefix}.결재란.작성자.이름`]);
      this.$set(this.form.sign1, "sign", translate[`${prefix}.결재란.작성자.서명`]);
      this.$set(this.form.sign2, "name", translate[`${prefix}.결재란.검토자.이름`]);
      this.$set(this.form.sign2, "sign", translate[`${prefix}.결재란.검토자.서명`]);
      this.$set(this.form.sign3, "name", translate[`${prefix}.결재란.회람자.이름`]);
      this.$set(this.form.sign3, "sign", translate[`${prefix}.결재란.회람자.서명`]);
      this.$set(this.form.sign4, "name", translate[`${prefix}.결재란.승인자.이름`]);
      this.$set(this.form.sign4, "sign", translate[`${prefix}.결재란.승인자.서명`]);

      const photoList = translate[`${prefix}.사진대지`];
      if (Array.isArray(photoList)) {
        const _photoList = JSON.parse(JSON.stringify(this.form.photoList && this.form.photoList.length ? this.form.photoList : []));
        for (let i = 0; i < photoList.length; i++) {
          if (!_photoList[i]) _photoList[i] = {};
          _photoList[i].input = photoList[i]["사진설명"];
        }
        this.$set(this.form, "photoList", _photoList);
      }

      const fileList = translate[`${prefix}.파일첨부`];
      if (Array.isArray(fileList)) {
        const _fileList = fileList.map((item) => ({
          fileName: item["파일명"],
          url: item["파일경로"],
        }));
        this.$set(this.form, "fileList", _fileList);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

input[type="number"] {
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.7rem !important;
  transition: all 0.3s ease;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
